import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class SendEmailApi extends BaseApi {
  async addSendEmail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
      {
        url: "/email/addsendemail",
        data: data,
        method: "post"
      }
    )
  }


  async getAllComposedMails(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
        {
            url:"/email/getallcomposedmails",
            method: "get"
        }
    )
}

async deleteMail(data: Record<string, unknown> | object, mail_id: IdLike): Promise<any> {
  return await this.API({
    url: `/email/deletemail/${mail_id}`,
    data: data,
    method: 'delete'
  })
}


}

export default SendEmailApi;
